function isPlatformNodeJS() {
  return typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]";
}

export { isPlatformNodeJS };
//# sourceMappingURL=platform.is-node.js.map
